import React, { useEffect, useState } from 'react';
import { cellRendererCheck, currencyFormat, dateFormate } from 'utils/columns';
import ReactStrapTable from 'components/reactStrapTable';
// import { faL } from '@fortawesome/free-solid-svg-icons';
// import { decimalFormat } from 'utils/columns';

const columns = [
    {
        dataField: 'options',
        text: 'Options',
        sort: false,
        width: 100,
        show: true,
        hidecolFilter: true,
        action: true
    },
    {
        dataField: 'drugAdminDate',
        text: 'Service Date',
        sort: true,
        width: 140,
        show: true,
        inputType: 'date',
        hideColFilter: false,
        cellRenderer: (rowData) => dateFormate(rowData.drugAdminDate),
    },
    {
        dataField: 'chargeCode',
        text: 'Charge Code',
        sort: true,
        width: 150,
        show: true,
        inputType: 'text',
        hideColFilter: false,
        cellRenderer: (rowData) => cellRendererCheck(rowData.chargeCode),
    },
    {
        dataField: 'chargeDescription',
        text: 'Charge Description',
        sort: true,
        width: 260,
        show: true,
        inputType: 'text',
        hideColFilter: false,
        cellRenderer: (rowData) => cellRendererCheck(rowData.chargeDescription),
    },
    {
        dataField: 'dispensedQuantity',
        text: 'Qty',
        sort: true,
        width: 120,
        show: true,
        inputType: 'number',
        hideColFilter: false,
        cellRenderer: (rowData) => cellRendererCheck(rowData.dispensedQuantity),
    },
    {
        dataField: 'bupp',
        text: 'BUPP',
        sort: true,
        width: 100,
        show: true,
        inputType: 'number',
        hideColFilter: false,
        cellRenderer: (rowData) => cellRendererCheck(rowData.bupp),
    },
    {
        dataField: 'quantity',
        text: 'Packages',
        sort: true,
        width: 140,
        show: true,
        inputType: 'number',
        hideColFilter: false,
        cellRenderer: (rowData) => cellRendererCheck(rowData.quantity),
    },
    {
        dataField: 'patientType',
        text: 'Patient Type',
        sort: true,
        width: 200,
        show: true,
        inputType: 'text',
        hideColFilter: false,
        cellRenderer: (rowData) => cellRendererCheck(rowData.patientType),
    },
    {
        dataField: 'serviceLocationDesc',
        text: 'Location',
        sort: true,
        width: 200,
        show: true,
        inputType: 'text',
        hideColFilter: false,
        cellRenderer: (rowData) => cellRendererCheck(rowData.serviceLocationDesc),
    },
    {
        dataField: 'visitNumber',
        text: 'Visit #',
        sort: true,
        width: 100,
        show: true,
        inputType: 'text',
        hideColFilter: false,
        cellRenderer: (rowData) => cellRendererCheck(rowData.visitNumber),
    },
    {
        dataField: 'mrNumber',
        text: 'MRN #',
        sort: true,
        width: 110,
        show: true,
        inputType: 'text',
        hideColFilter: false,
        cellRenderer: (rowData) => cellRendererCheck(rowData.mrNumber),
    },

];

const AccumulationTables = ({
    tenantID,
    data,
    loading,
    onExport,
    filters,
    totalSize,
    onPageChange,
    refetch,
    setLoading,
    onSearchColumnFilters,
    reset,
}) => {
    const [state, updateState] = useState({
        tableData: [],
        backUpData: [],
        filters: filters,
    });
    useEffect(() => {
        setState({ tableData: data, backUpData: data });
    }, [data]);
    const setState = (obj) => updateState(pre => ({ ...pre, ...obj }));

    useEffect(() => {
        setState({ filters: filters });
    }, [filters]);

    const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            return onPageChange(colFilterOn, true);
        }
        setState({
            filters: filter,
        });
        onPageChange(filter);
    };

    const handleFilterCancel = () => {
        refetch(true);
    };

    const handleSearchColumnFilters = (colFilter) => {
        debugger
        if (onSearchColumnFilters) {
            const filter = { ...state.filters, filters: colFilter, currentPage: 1 };
            onSearchColumnFilters(filter);
            setState({
                filters: filter,
            });
        }
    };

    const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
        
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            onPageChange(colFilterOn, true);
        } else {
            setState({
                filters: filter,
            });
            onPageChange(filter);
        }
    };


    const handleSort = (filter, hasColFilter) => {
        debugger;
        setState({
            filters: filter,
        });
        if (hasColFilter) {
            onPageChange(filter, true);
        } else {
            onPageChange(filter);
        }
    };

    const { filters: colFilter, backUpData } = state;

    return <div className="table-card scroll-table position-relative border-0 rounded pt-0"
        fixed-height={data?.length > 0 ? 'fixed-height' : 'default'}>
        <ReactStrapTable
            id='configuration-table1'
            fixedColumn
            data={backUpData}
            loading={loading}
            columns={columns}
            hasPagination = {backUpData?.length>0 ?true : false}
            onPageSizeChange={onPageSizeChange}
            pageSize={colFilter.pageSize}
            onExport={onExport}
            onPageChange={onHandlePageChange}
            currentPage={colFilter.currentPage}
            totalRecords={totalSize}
            handleSort={handleSort}
            onFilterCancel={handleFilterCancel}
            filters={colFilter}
            onSearchColumnFilters={handleSearchColumnFilters}
        />
    </div>;
};

export default AccumulationTables;
